import { space } from '@op/opds-tokens';
import { Button, Col, Row, Tile } from '@op/opds.opux';
import { IconSustainability, IconSustainabilityhigh } from '@op/opds.opux-icons/finance';
import { Message, useMessage } from '@messageformat/react';
import { replaceSpecialChars } from '../common';

interface Props {
  fundName: string;
  profitExpectation: number;
  riskCategory: number;
  responsibility: number;
  fundDescription: string;
  isPersonCustomer: boolean;
  index: number;
  bonusAccrual: number;
}
const FundComponent = (props: Props): JSX.Element => {
  const {
    fundName,
    profitExpectation,
    riskCategory,
    responsibility,
    fundDescription,
    isPersonCustomer,
    index,
    bonusAccrual,
  } = props;
  const fundsPageUrl = useMessage('fundsPageUrl');
  const fundsPageUrlCorp = useMessage('corp_fundsPageUrl');

  const setResponsibilityElement = (): JSX.Element | null => {
    if (responsibility === 8) {
      return (
        <Col xs={6}>
          <IconSustainability
            size="large"
            color="positive"
            style={{ margin: 'auto', display: 'block' }}
          />
          <p
            style={{ textAlign: 'center', fontWeight: 'medium' }}
            className="fundcomponent-body medium"
          >
            <Message id="fundComponent_sustainable" />
          </p>
        </Col>
      );
    }
    if (responsibility === 9) {
      return (
        <Col xs={6}>
          <IconSustainabilityhigh
            size="large"
            color="positive"
            style={{ margin: 'auto', display: 'block' }}
          />
          <p
            style={{ textAlign: 'center', fontWeight: 'medium' }}
            className="fundcomponent-body medium"
          >
            <Message id="fundComponent_highlySustainable" />
          </p>
        </Col>
      );
    }
    return null;
  };

  const riskLevelText = (): JSX.Element => {
    if (riskCategory === 1) {
      return <Message id="fundComponent_very_low" />;
    }
    if (riskCategory === 2 || riskCategory === 3) {
      return <Message id="fundComponent_low" />;
    }
    if (riskCategory === 4 || riskCategory === 5) {
      return <Message id="fundComponent_average" />;
    }
    return <Message id="fundComponent_high" />;
  };

  const titleId = `fundBox-title-${index}`;
  const buttonId = `fundBox-button-${index}`;
  const labelledBy = `${titleId} ${buttonId}`;

  return (
    <Tile style={{ flexGrow: 1, minHeight: '460px' }}>
      <h3 id={titleId} className="fundcomponent-title">
        {fundName}
      </h3>
      <p className="fundcomponent-body" style={{ minHeight: '100px' }}>
        {fundDescription}
      </p>
      <Row style={{ paddingTop: space.small }}>
        <Col xs={responsibility === 8 || responsibility === 9 ? 6 : 12}>
          <Col>
            <div className={`fundcomponent-indicator level${riskCategory}`} />
          </Col>
          <Col style={{ textAlign: 'center' }}>
            <dl>
              <dt className="fundcomponent-body medium">
                <Message id="fundComponent_riskLevel" />
              </dt>
              <dd className="fundcomponent-riskLevel">
                {riskLevelText()} ({riskCategory}/7)
              </dd>
            </dl>
          </Col>
        </Col>

        {setResponsibilityElement()}
      </Row>
      <Row style={{ paddingTop: space.default }}>
        <Col xs={4}>
          <p className="fundcomponent-profitExpectation">
            {profitExpectation.toLocaleString('fi-FI', {})} %
          </p>
        </Col>
        <Col xs={8} className="fundcomponent-body">
          <Message id="fundComponent_profitAfterExpenses" />
        </Col>
      </Row>
      <Row style={{ paddingTop: space.small }}>
        <Col xs={4}>
          <p className="fundcomponent-bonus">
            {bonusAccrual !== 0 ? `${bonusAccrual.toLocaleString('fi-FI', {})} %` : ''}
          </p>
        </Col>
        <Col xs={8} className="fundcomponent-body">
          {bonusAccrual === 0 ? (
            <Message id="fundComponent_noBonus" />
          ) : (
            <Message id="fundComponent_ownerCustomer" />
          )}
        </Col>
      </Row>
      <div style={{ textAlign: 'center' }}>
        <Button
          id={buttonId}
          aria-labelledby={labelledBy}
          href={
            isPersonCustomer
              ? `${fundsPageUrl + replaceSpecialChars(fundName).toLowerCase()}/`
              : `${fundsPageUrlCorp + replaceSpecialChars(fundName).toLowerCase()}/`
          }
          style={{ marginTop: space.default }}
        >
          <Message id="fundComponent_readMore" />
        </Button>
      </div>
    </Tile>
  );
};

export default FundComponent;
